import { BaseService } from "./qrscanner.baseservice";
import {
  TicketScanErrorResponse,
  TicketScanRequest,
  TicketScanOKResponse,
  TicketFormRequest,
  QrTicketScanRequest,
} from "@/store/qrscanner/types";
import {
  EventLoginErrorResponse,
  EventLoginOKResponse,
  EventLoginRequest,
  GetEventInfoResponse,
} from "@/store/auth/types";

import { AuthModule } from "@/store/auth";

class QRScannerService extends BaseService {
  private static _qrscannerService: QRScannerService;

  private constructor(controllerName: string) {
    super(controllerName);
  }

  public static get Instance(): QRScannerService {
    return (
      this._qrscannerService || (this._qrscannerService = new this("qrscanner"))
    );
  }

  public async EventLogin(
    request: EventLoginRequest
  ): Promise<EventLoginOKResponse | EventLoginErrorResponse> {
    const response = await this.$http.post("/eventlogin", request);

    if (response.data.success === true) {
      const res: EventLoginOKResponse = {
        success: response.data.success,
        error: response.data.error,
        data: {
          token: response.data.data.token,
          eventID: response.data.data.eventID,
          eventInfo: response.data.data.eventInfo,
        },
      };
      try {
        if (res.success && res.data.eventInfo.eventColor) {
          const style: any = document.getElementById("app")!.style;
          style["background-color"] = res.data.eventInfo.eventColor;
        }
      } catch (_err) {
        console.log("Login Change BG Color ERR", _err);
      }

      return res;
    } else {
      const res: EventLoginErrorResponse = {
        success: response.data.success,
        error: response.data.error,
        data: response.data.data ? { eventInfo: response.data.data.eventInfo } : undefined,
      };
      return res;
    }
  }

  public async GetEventInfo(): Promise<GetEventInfoResponse | null> {
    const token = AuthModule.currentEventToken;

    if (token === null) {
      return null;
    }
    const response = await this.$http.get("geteventinfo", {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return {
      success: response.data.success,
      error: response.data.error,
      data: {
        eventInfo: response.data.data.eventInfo,
        eventID: response.data.data.eventID,
      },
    };
  }

  public async ScanTicket(
    request: TicketScanRequest
  ): Promise<TicketScanOKResponse | TicketScanErrorResponse> {
    const token = AuthModule.currentEventToken;
    const response = await this.$http.get(request.url, {
      params: {
        eventType: request.eventType,
      },
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return {
      success: response.data.success,
      error: response.data.error,
    };
  }

  public async ScanTicketQr(
    request: QrTicketScanRequest
  ): Promise<TicketScanOKResponse | TicketScanErrorResponse> {
    const token = AuthModule.currentEventToken;
    const response = await this.$http.post("https://livestream-api.equipovision.com/api/digital/updateQrAttendance", request, { headers: { "Content-Type": "application/json" } }
      // const response = await this.$http.post("http://localhost:3009/api/digital/updateQrAttendance", request,{headers: {"Content-Type": "application/json"}}
    );
    response.data.success = false;
    if (response.data.ok === 1) {
      response.data.success = true;
    }
    return {
      success: response.data.success,
      error: response.data.error,
    };
  }

  public async ScanTicketForm(
    request: TicketFormRequest
  ): Promise<TicketScanErrorResponse | TicketScanOKResponse> {
    const token = AuthModule.currentEventToken;
    const response = await this.$http.post("scanticketform", request, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return {
      success: response.data.success,
      error: response.data.error,
    };
  }
}

export const QRScannerServiceApi = QRScannerService.Instance;
